import { RootState } from '@src/store/store'
import { TariffsStateType } from '@src/store/ducks/subscriptions/reducer'

export const selectSubscriptions = (state: RootState): TariffsStateType => state.subscriptions
export const selectSubscriptionsList = (state: RootState) => selectSubscriptions(state).subscriptions
export const selectSubscriptionsIsLoading = (state: RootState) => selectSubscriptions(state).isLoading
export const selectSubscriptionsIsSuccessChange = (state: RootState) => selectSubscriptions(state).isSuccessChangeSubscription
export const selectSubscriptionsIsLoadingChange = (state: RootState) => selectSubscriptions(state).isLoadingChangeSubscription
export const selectSubscriptionsSuccessMessage = (state: RootState) => selectSubscriptions(state).subscriptionSuccessMessage
